import Button from 'components/Button';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import Pill from 'components/Pill';
import SectionHeader from 'components/SectionHeader';
import {FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useBackend} from 'state/backend';

import DeleteTagModal from './DeleteTagModal';
import RenameTagModal from './RenameTagModal';
import {Tag, TagsSettingsBackend} from './types';

const TagsSettings: FC = () => {
    const {
        data: {tags},
        flags,
    } = useBackend<TagsSettingsBackend>();
    const {t} = useTranslation('Partner.TagsSettings');

    const [tagForRenaming, setTagForRenaming] = useState<Tag | undefined>(
        undefined,
    );
    const [tagForRemoval, setTagForRemoval] = useState<Tag | undefined>(
        undefined,
    );

    return (
        <>
            <NavigationTabs.DocumentSettings flags={flags} selection="tags" />
            <SectionHeader
                subtitle={tags.length > 0 ? t('subtitle') : t('subtitleEmpty')}
                title={t('title')}
            />
            <div className="mt-4">
                {tags.map((tag) => (
                    <div
                        className="flex w-full justify-between gap-2 border-b border-b-grey-300 py-3"
                        key={tag.id}
                    >
                        <div className="flex flex-1 flex-wrap">
                            <Pill color="grey" key={tag.id} label={tag.name} />
                        </div>
                        <div className="flex items-center gap-2">
                            <Button
                                icon="edit"
                                id={`rename-${tag.id}`}
                                kind="secondary"
                                onClick={() => {
                                    setTagForRenaming(tag);
                                }}
                                size="xs"
                            >
                                {t('rename')}
                            </Button>
                            <Button
                                icon="trash"
                                id={`delete-${tag.id}`}
                                kind="destructive"
                                onClick={() => {
                                    setTagForRemoval(tag);
                                }}
                                size="xs"
                            >
                                {t('remove')}
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
            {tagForRenaming && (
                <RenameTagModal
                    isOpen={!!tagForRenaming}
                    onClose={() => {
                        setTagForRenaming(undefined);
                    }}
                    tag={tagForRenaming}
                />
            )}
            {tagForRemoval && (
                <DeleteTagModal
                    isOpen={!!tagForRemoval}
                    onClose={() => {
                        setTagForRemoval(undefined);
                    }}
                    tag={tagForRemoval}
                />
            )}
        </>
    );
};

export default TagsSettings;
